import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as JSZip from "jszip";

import Multiselect from "vue-multiselect";
// import VueNumeric from "vue-numeric";

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

import VuePromiseBtn from "vue-promise-btn";
import { ModalPlugin, ToastPlugin } from "bootstrap-vue";

import selectOnFocus from "vue-select-on-focus";

// router setup
import routes from "./routes/routes";

// Loader Spinner
import { RotateSquare2 } from "vue-loading-spinner";
import store from "./store/store";
import VueTheMask from "vue-the-mask";

try {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  window.JSZip = JSZip;
  require("datatables.net-buttons-bs4/js/buttons.bootstrap4.min");
  require("datatables.net-buttons/js/buttons.html5.js");

  window.$ = window.jQuery = require("jquery");

  require("bootstrap");
  window.Swal = require("sweetalert2/dist/sweetalert2.min");

  window.axios = require("axios");
  window.axios.defaults.baseURL = `//${process.env.VUE_APP_URL}/api/`;
  window.axios.defaults.withCredentials = true;
  window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
} catch (e) {
  console.log(e);
}

Vue.component("multiselect-item", Multiselect);

// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(VuePromiseBtn);
Vue.use(ModalPlugin);
Vue.use(ToastPlugin);
Vue.use(selectOnFocus);
Vue.use(VueTheMask);

Vue.prototype.$msgBoxOk = async function (msg, options = { centered: true }) {
  return this.$bvModal.msgBoxOk(msg, options);
};

const moment = require("moment");
require("moment/locale/es");

Vue.use(require("vue-moment"), {
  moment,
});

Vue.component("loading-item", RotateSquare2);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (localStorage.getItem("loggedIn") || to.path === "/login") {
    next();
  } else {
    next({ path: "/login" });
  }
});

// Add a 401 response interceptor
// La sesión es una cookie de Laravel: no existe mecanismo de refresh.
// Un 401 significa sesión vencida → limpiar la sesión local y volver al login.
window.axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response && response.status === 401) {
      ["usuario", "permisos", "loggedIn"].forEach((k) =>
        localStorage.removeItem(k),
      );
      if (router.currentRoute.path !== "/login") {
        router.push("/login").catch(() => {});
      }
    }

    return Promise.reject(error);
  },
);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
});
